<template>
  <b-modal
    hide-footer
    size="sm"
    title="Permanent Self Exclude"
    centered
    id="permanent-self-exclude-modal"
  >
    <div class="text-center">
      <h3 class="font-weight-bold text-black">Permanent Self Exclude</h3>
    </div>

    <div
      class="w-100 text-center p-1"
      style="background: #ffe5e5; border-radius: 10px; color: #d10000"
    >
      <p class="font-weight-bold">
        Permanant Exclusion is definite<br />
        &amp; cannot be reversed.
      </p>
    </div>

    <p class="text-center text-black mt-2 font-weight-bolder">
      This will permanently close the betting<br />
      account this can not be undone.
    </p>

    <!-- BULLET NOTES -->
    <div class="text-black mt-1">
      <p>With permanent exclusion, please note:</p>
      <ul>
        <li>All pending Bets will stand</li>
        <li>
          Outstanding balance will be automatically withdrawn to last active
          withdrawal method when pending bets are resulted
        </li>
        <li>
          You will not be able to log into your account or create a new account
        </li>
        <li>
          You will no longer receive marketing material from us within 24 hours
        </li>
      </ul>
    </div>

    <b-form-group
      label="Reason*"
      class="text-black"
      label-class="font-weight-bold"
    >
      <b-form-textarea
        v-model="form.reason"
        placeholder="Provide reason here"
        rows="3"
        class="rounded-lg"
      ></b-form-textarea>
    </b-form-group>

    <!-- PRIMARY BUTTON -->
    <b-button
      variant="danger"
      class="w-100 font-weight-bold mt-2"
      :disabled="loadingClientProfile"
      @click="handleSubmit"
    >
      PERMANENTLY SELF-EXCLUDE
    </b-button>

    <!-- CANCEL BUTTON -->
    <b-button
      class="w-100 mt-1 font-weight-bold"
      @click="$bvModal.hide('permanent-self-exclude-modal')"
    >
      CANCEL
    </b-button>
  </b-modal>
</template>

<script>
import { BModal, BFormGroup, BFormTextarea, BButton } from "bootstrap-vue";
import { mapState, mapActions } from "vuex";
import useToastHandler from "@/services/toastHandler";

export default {
  components: { BModal, BFormGroup, BFormTextarea, BButton },
  data() {
    return {
      form: {
        reason: "",
      },
    };
  },
  computed: {
    ...mapState("user/detail", ["loadingClientProfile"]),
  },
  methods: {
    ...mapActions({
      updateClientProfile: "user/detail/updateClientProfile",
      fetchUser: "user/detail/asyncUser",
    }),
    async handleSubmit() {
      const result = await this.updateClientProfile({
        userId: this.$route.params.id,
        selfExcluded: 1,
        reasonUpdate: this.form.reason,
      });
      if (result) {
        this.showToastSuccess("Permanent Self Exclude successfully!");
        this.hideModal();
        this.fetchUser({ id: this.$router.currentRoute.params.id });
      }
    },
    hideModal() {
      this.form.reason = "";
      this.$bvModal.hide("permanent-self-exclude-modal");
    },
  },
  setup() {
    const { showToastSuccess, showToastError } = useToastHandler();
    return {
      showToastSuccess,
      showToastError,
    };
  },
};
</script>
